// src/Header.js

import React from 'react';
import { Link } from 'react-router-dom';

// Jednoduchý komponent pre hlavičku
export default function Header() {
    return (
        <header>
            <h1>Účtovné a administratívne služby</h1>
        </header>
    );
}
